import React from 'react';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import TaxStrategyTabTemplate
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy';
import AccountAllocationTabTemplatePicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/accountAllocationTabTemplatePicker';
import GoalDetailsTabTemplate
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/GoalDetails';
import SummaryTabTemplate from './Summary';
import AllocationsTabTemplate from './Allocations';
import ScenarioDetailsTabTemplate from './ScenarioDetails';
import NextUpTabTemplate from './NextUp';

const tabResourceTypeToComponentMap = {
  outcomeSummary: SummaryTabTemplate,
  categorizedGoals: GoalDetailsTabTemplate,
  allocationDetails: AllocationsTabTemplate,
  scenarioDetails: ScenarioDetailsTabTemplate,
  taxStrategy: TaxStrategyTabTemplate,
  accountDetails: AllocationsTabTemplate,
  realAssetDetails: AllocationsTabTemplate,
  sacStepDetails: AllocationsTabTemplate,
  accountActionAllocationDetails: AccountAllocationTabTemplatePicker,
  nextUpDetails: NextUpTabTemplate,
};

const TabTemplatePicker = () => {
  // Get selected tab resourceType from context
  const { activeTabResourceType } = useTabContentContext();

  // Set template Component by resource type selected
  const TabComponent = tabResourceTypeToComponentMap[activeTabResourceType];

  if (TabComponent) {
    return <TabComponent />;
  }

  return null;
};

export default TabTemplatePicker;
